interface LogoProps {
  width: string
  stroke: string
}

export default function Logo(props: LogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      id="_x3C_Layer_x3E_"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.width}
      stroke={props.stroke}
    >
      <g id="car_x2C__electric_car_x2C__vehicle">
        <g id="XMLID_667_">
          <path
            d="    M27.2,13.499H30c0.276,0,0.5,0.223,0.5,0.5v1c0,0.276-0.212,0.57-0.475,0.658"
            fill="none"
            id="XMLID_4189_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M6.5,26.999v2.5c0,0.552-0.447,1-1,1h-2c-0.553,0-1-0.448-1-1v-2.5"
            fill="none"
            id="XMLID_674_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M29.5,26.499v3c0,0.552-0.447,1-1,1h-2c-0.553,0-1-0.448-1-1v-3"
            fill="none"
            id="XMLID_677_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M4.8,13.499H2c-0.276,0-0.5,0.223-0.5,0.5v1c0,0.276,0.212,0.57,0.475,0.658"
            fill="none"
            id="XMLID_882_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M4.109,17.003l1.494-6.74c0.267-1.2,1.233-2.121,2.448-2.313c0.851-0.133,1.908-0.262,3.479-0.348"
            fill="none"
            id="XMLID_683_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M20.967,7.631c1.303,0.085,2.225,0.201,2.981,0.319c1.215,0.192,2.182,1.113,2.448,2.313l1.494,6.741"
            fill="none"
            id="XMLID_680_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M29.5,26.499h-27c-0.553,0-1-0.448-1-1v-1h29v1C30.5,26.051,30.053,26.499,29.5,26.499z"
            fill="none"
            id="XMLID_684_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M1.5,21.999v-2.5c0-2.938,3.583-3,14.5-3s14.5,0.063,14.5,3v2.188"
            fill="none"
            id="XMLID_689_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M30.5,19.499v3h-6v-2c0-0.553,0.447-1,1-1h3"
            fill="none"
            id="XMLID_690_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M3.5,19.499h3c0.553,0,1,0.447,1,1v2h-6v-3"
            fill="none"
            id="XMLID_691_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />

          <path
            d="    M9.5,22.499v-1c0-1.1,0.9-2,2-2h9c1.1,0,2,0.9,2,2v1"
            fill="none"
            id="XMLID_692_"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>

        <polyline
          fill="none"
          id="XMLID_1095_"
          points="   16.5,6.498 17.5,1.498 12.5,9.498 15.5,9.498 14.5,14.498 19.5,6.498  "
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  )
}
